
const uploadImage = (access_token, image, imageable_id, imageable_type, data) => {
	return new Promise((resolve, reject) => {
		var formData = new FormData()
		formData.append('image', image)
		formData.append('imageable_id', imageable_id)
		formData.append('imageable_type', imageable_type)
		if(data?.replace) formData.append('replace', data.replace)
		if(data?.fit) formData.append('fit', data.fit)
		if(data?.width) formData.append('width', data.width)
		if(data?.height) formData.append('height', data.height)
		axios.post('/api/image', formData, { headers: {
			Accept: 'application/json',
			Authorization: access_token ? ('Bearer ' + access_token) : null,
		}}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const deleteImage = (access_token, image_id) => {
	return new Promise((resolve, reject) => {
		axios.delete('/api/image/' + image_id, { headers: {
			Accept: 'application/json',
			Authorization: access_token ? ('Bearer ' + access_token) : null,
		}}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export {
	uploadImage,
	deleteImage
}